export default () => ({
	selected: 0,
	width: '0%',

	stars: {
		['x-bind:class']() {
			return {
				'cursor-pointer': true,
			}
		},

		['@mouseover.debounce'](e) {
			// Get element left side.
			const { left } = this.$root.getBoundingClientRect()
			// Get mouse position.
			const { clientX } = e
			// Calculate width.
			let width = ((clientX - left) / this.$root.offsetWidth) * 100
			if (width > 95) {
				width = 100
			}

			// ceil width to nearest 20
			width = Math.ceil(width / 20) * 20

			this.width = `${width}%`
		},

		['@mouseout.debounce']() {
			this.width = `${this.selected}%`
		},

		['@click']() {
			this.selected = parseInt(this.width)
			this.$dispatch('rating-selected', this.selected)
		},
	},

	overlayStars: {
		['x-bind:style']() {
			return {
				maxWidth: this.width,
			}
		},
	},
})
